import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  footer: {
    margin: '3rem 0',
    padding: '0 1rem',
    width: '100%',
  },
  helpAndPolicies: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    fontSize: '0.8rem',
    '& a': {
      color: theme.darkSlateGrayColor,
      textDecoration: 'none',
    },
  },
  help: {
    width: 'max-content',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  horizontalLine: {
    borderBottom: `1px solid ${theme.snowColor}`,
  },
  policies: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '2rem',
  },
}));

export default useStyles;
